import React from "react";
import { Card, Skeleton, Table } from "antd";
import "./TableWithChart.scss";
import HalfDonutPieChart from "../HalfDonutPieChart/HalfDonutPieChart";
import { formatCurrency, formatWithCommas } from "../../assets/helpers";
import moment from "moment";
import { useSelector } from "react-redux";

const TableWithChart = ({ data, loading = false }) => {
   const { format } = useSelector((state) => state.priceFormat);
  const columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (text) =>
        loading ? <Skeleton.Input size="small" active /> : text,
    },
    {
      title: "Trust",
      dataIndex: "trustname",
      key: "trustname",
      render: (text) =>
        loading ? <Skeleton.Input size="small" active /> : text,
    },
    {
      title: "Value of Trust",
      dataIndex: "value_of_trust",
      key: "value_of_trust",
      render: (text) =>
        loading ? <Skeleton.Input size="small" active /> : formatCurrency(text,format) || 0,
    },
    {
      title: "No. of cases",
      dataIndex: "no_of_cases",
      key: "no_of_cases",
      render: (text) =>
        loading ? <Skeleton.Input size="small" active /> : formatWithCommas(text || 0) || 0,
    },
    {
      title: "Created on",
      dataIndex: "created_on",
      key: "created_on",
      render: (text) =>
        loading ? <Skeleton.Input size="small" active /> : moment(text, "YYYY-MM-DD").format("DD/MM/YYYY") || '-',
    },
    {
      title: "Last updated",
      dataIndex: "last_updated",
      key: "last_updated",
      render: (text) =>
        loading ? <Skeleton.Input size="small" active /> : moment(text, "YYYY-MM-DD").format("DD/MM/YYYY") || '-',
    },
    {
      title: "Recovered vs Balance",
      dataIndex: "recovered_percentage",
      key: "recovered_percentage",
      render: (text,item) =>
        loading ? <Skeleton.Input size="small" active /> :  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <HalfDonutPieChart
            data={[
              { name: "Recovered", value: item?.recovered_percentage || 0 },
              { name: "Pending", value: item?.pending_percentage || 0 },
            ]}
          />
          <div className="wrapper_box">
            <div className="recovered_text">
              <h1>Recovered</h1>
              <h1>{item?.recovered_percentage || 0 }%</h1>
            </div>
            <div className="balanced_text">
              <h1>Pending</h1>
              <h1>{item?.pending_percentage || 0}%</h1>
            </div>
          </div>
        </div>,
    },
    {
      title: "",
      dataIndex: "morevert",
      key: "morevert",
      render: (text) =>
        loading ? <Skeleton.Input size="small" active /> : text,
    },
  ];

  return (
    <Card className="tableWithChartMain">
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        className="custom-table"
      />
    </Card>
  );
};

export default TableWithChart;
